const ADD_USER = "ADD_USER";
const LOGIN = "LOGIN";
const ISLOGGED = "ISLOGGED";
const GET_USER_WITH_ID = "GET_USER_WITH_ID";

export { ADD_USER, LOGIN, GET_USER_WITH_ID, ISLOGGED };
